import React from 'react';
import { NationalAccount, PricingSummary, PreferredPricing, } from '../../components/PricingBenefits';
import { useIsMobile } from '../../hooks';
import { RewardsAndOffersContext } from '../../contexts';
import '../../styles/app.scss';
export var PricingBenefitsContainer = function () {
    var _a;
    var isMobile = useIsMobile().isMobile;
    var _b = React.useContext(RewardsAndOffersContext), isLoading = _b.isLoading, rewardsAndOffers = _b.rewardsAndOffers;
    return (React.createElement("div", { style: {
            visibility: isLoading ? 'hidden' : 'unset',
        } },
        (rewardsAndOffers === null || rewardsAndOffers === void 0 ? void 0 : rewardsAndOffers.customerInfo) && (React.createElement(PricingSummary, { isMobile: isMobile, proXtraSpend: rewardsAndOffers === null || rewardsAndOffers === void 0 ? void 0 : rewardsAndOffers.proXtraSpend, userProfile: rewardsAndOffers === null || rewardsAndOffers === void 0 ? void 0 : rewardsAndOffers.userProfile })),
        React.createElement(PreferredPricing, { isMobile: isMobile }),
        React.createElement(NationalAccount, { isMobile: isMobile, nationalAccount: (_a = rewardsAndOffers === null || rewardsAndOffers === void 0 ? void 0 : rewardsAndOffers.customerInfo) === null || _a === void 0 ? void 0 : _a.nationalAccountDetails })));
};
